module.exports = __webpack_public_path__ + "img/Kingo_Om_salmelitteraturen.fb47b0f8.jpg";